export default "__VITE_ASSET__D649IVwj__"